import { css } from '@emotion/react';

export default css`
  --global-header-height: 72px;
`;
